<template>
  <v-flex layout align-top justify-center>
    <div class="frame">
      <!--@click="click($event)" -->
      <image-input
        v-if="!answerImage"
        class="imageClass"
        :default="answerImage"
        :showImageInfos="false"
        :langEdition="langEdition"
        :type="'target'"
        @change-image-input="updateAnswerImage"
      ></image-input>
      <v-img
        v-if="answerImage"
        :src="answerImage.url"
        class="imageClass"
        :width="imageWidth"
        :height="imageHeight"
      >
        <vue-resizable
          class="target"
          ref="resizableComponent"
          :dragSelector="dragSelector"
          :active="handlers"
          :fit-parent="fit"
          :max-width="imageWidth"
          :max-height="imageHeight"
          :min-width="10"
          :min-height="10"
          :width="targetWidth"
          :height="targetHeight"
          :left="left"
          :top="top"
          @mount="eHandler"
          @destroy="eHandler"
          @resize:move="eHandler"
          @resize:start="eHandler"
          @resize:end="eHandler"
          @drag:move="eHandler"
          @drag:start="eHandler"
          @drag:end="eHandler"
        >
          <div v-if="answerImage" class="block">
            <div class="drag-container" :style="areaStyle"></div>
            <!--@click="click($event)"
        
         -->
          </div>
        </vue-resizable>
      </v-img>
    </div>
  </v-flex>
</template>

<script>
import VueResizable from 'vue-resizable';
import ImageInput from './ImageInput';

export default {
  name: 'GameTargetZone',
  components: {
    ImageInput,
    VueResizable,
  },
  props: {
    parameters: {
      type: Object,
      default: null,
    },
    langEdition: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      answerImage: null,
      imageWidth: 200,
      imageHeight: 200,
      targetWidth: 130,
      targetHeight: 50,
      top: 75,
      left: 35,
      fit: true,
      event: '',
      dragSelector: '.drag-container',
      handlers: ['r', 'rb', 'b', 'lb', 'l', 'lt', 't', 'rt'],
    };
  },
  computed: {
    areaStyle() {
      return {
        top: '5px',
        left: '5px',
        height: `${this.targetHeight - 16}px`,
        width: `${this.targetWidth - 16}px`,
      };
    },
    zone() {
      return {
        zoneRelativeY: (this.top + this.targetHeight / 2) / this.imageHeight,
        zoneRelativeX: (this.left + this.targetWidth / 2) / this.imageWidth,
        zoneRelativeWidth: this.targetWidth / this.imageWidth,
        zoneRelativeHeight: this.targetHeight / this.imageHeight,
      };
    },
  },
  created() {
    console.log('param', this.parameters.zoneRelativeWidth);
    if (this.parameters.zoneRelativeWidth) {
      this.answerImage = this.parameters.picture;
      this.targetWidth = this.parameters.zoneRelativeWidth * this.imageWidth;
      this.targetHeight = this.parameters.zoneRelativeHeight * this.imageHeight;
      this.top =
        this.parameters.zoneRelativeY * this.imageHeight -
        this.targetHeight / 2;
      this.left =
        this.parameters.zoneRelativeX * this.imageWidth - this.targetWidth / 2;
    }
  },
  methods: {
    eHandler(data) {
      if (!['resize:end', 'drag:end'].includes(data.eventName)) {
        return;
      }
      this.targetWidth = data.width;
      this.targetHeight = data.height;
      this.left = data.left;
      this.top = data.top;
      this.$emit('update-zone', this.zone);
    },
    updateAnswerImage(newImage) {
      this.answerImage = newImage;
      this.$emit('update-answer-image', this.answerImage);
    },
  },
};
</script>

<style scoped lang="sass">
.imageClass
  position: relative
  top: 0px

.frame
  height: 200px;
  width: 200px

.target
  position: relative
  overflow: hidden
  background-color: transparent;
  z-index: 100
  border: 3px solid red

.drag-container
  position: relative
  overflow: hidden
  background-color: transparent;
  z-index: 100
  cursor: move;
</style>
